export default __webpack_public_path__ + "static/media/gospel.28ebcd1e.png";